export function truncateText(text, characterCount = 82) {
  if (text.length > characterCount) {
    return text.slice(0, characterCount-1).concat("...");
  } else {
    return text;
  }
}
